import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get values() {
    return { url: String }
  }

  visit() {
    Turbo.visit(this.urlValue)
  }
}
